/* unplugin-vue-components disabled */import { render } from "./collect.vue?vue&type=template&id=7b47c0b8&scoped=true"
import script from "./collect.vue?vue&type=script&lang=js"
export * from "./collect.vue?vue&type=script&lang=js"

import "./collect.vue?vue&type=style&index=0&id=7b47c0b8&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b47c0b8"]])

export default __exports__